import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container'
import Stack from 'react-bootstrap/Stack';
import Header from './components/Header';
import Footer from './components/Footer';
import Posts from './components/Stories';
import Body from './components/Body';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import LoginPage from './pages/babyboo/LoginPage';
import AboutUsPage from './pages/babyboo/AboutUsPage';
import ImagePage from './pages/babyboo/ImagePage';
import ImagesPage from './pages/babyboo/ImagesPage';
import StoryPage from './pages/babyboo/StoryPage';
import StoriesPage from './pages/babyboo/StoriesPage';
import TaskPage from './pages/task/tasks';

import TopoHomePage from './pages/topo/TopoHomePage';

function App() {

  return (
    <AuthProvider>
    <Container fluid className="App">
      <BrowserRouter>
      <Header/>
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/aboutus" element={<AboutUsPage />} />
      <Route path="/topo" element={<TopoHomePage />} />
      <Route
          path="/"
          element={
              <ProtectedRoute>
                  <ImagesPage />
              </ProtectedRoute>
          }
      />
      <Route
          path="/task"
          element={
                  <TaskPage />
          }
      />
      <Route
          path="/stories"
          element={
              <ProtectedRoute>
                  <StoriesPage />
              </ProtectedRoute>
          }
      />
      <Route
          path="/story/:storyuuid"
          element={
              <ProtectedRoute>
                  <StoryPage />
              </ProtectedRoute>
          }
      />
      <Route
          path="/share/:imguuid"
          element={
                  <ImagePage />
          }
      />
      <Route
          path="/dashboard"
          element={
              <ProtectedRoute>
                  <Dashboard />
              </ProtectedRoute>
          }
      />
    </Routes>
    
    </BrowserRouter>
    </Container>
    </AuthProvider>
  );
}

export default App;